import type { StackProps } from '@chakra-ui/react'
import { Stack, Separator } from '@chakra-ui/react'
import type { FC } from 'react'

const CommentList: FC<StackProps> = (props) => <Stack gap="6" separator={<Separator />} {...props} />

export default CommentList
